export default __webpack_public_path__ + "static/HomepageFooterCtaBg-407977e1ab2cbabbc4a4e874d3f194fe.jpg";